<template>
    <div>
        <div class="listing-header">
            <div class="title-breadcrumb">
                <h1 class="title">
                    {{ title }}
                </h1>
            </div>
        </div>


        <div class="form-columns-fit">
            <div class="columns is-flex-wrap">
                <div class="column is-12">
                    <v-input
                        :id="generateId(1)"
                        ref="nomeCientificoInput"
                        title="nomecientifico"
                        v-model="ocorrencia.nomecientifico"
                        :disabled="true"
                    />
                </div>
                <div class="column is-6">
                    <v-textarea
                        :id="generateId(2)" 
                        ref="ocorrenciaIdentificar"
                        v-model="ocorrencia.identificar"
                        title="ocorrencia-identificar"
                        :rows="6"
                        :maxRows="6"
                        :disableTransform="true"
                        :disabled="true"
                    />
                </div>
                <div class="column is-6">
                    <v-textarea
                        :id="generateId(3)" 
                        ref="ocorrenciaPerdas"
                        v-model="ocorrencia.perdas"
                        title="ocorrencia-perdas"
                        :rows="6"
                        :maxRows="6"
                        :disableTransform="true"
                        :disabled="true"
                    />
                </div>
                <div class="column is-6">
                    <v-textarea
                        :id="generateId(4)" 
                        ref="ocorrenciaManejo"
                        v-model="ocorrencia.manejo"
                        title="ocorrencia-manejo"
                        :rows="6"
                        :maxRows="6"
                        :disableTransform="true"
                        :disabled="true"
                    />
                </div>
                <div class="column is-6">
                    <v-textarea
                        :id="generateId(5)" 
                        ref="ocorrenciaControlar"
                        v-model="ocorrencia.controlar"
                        title="ocorrencia-controlar"
                        :rows="6"
                        :maxRows="6"
                        :disableTransform="true"
                        :disabled="true"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
// #71161
import OcorrenciaService from "@/services/agro/ocorrencia/OcorrenciaService";

export default {
    props: {
        idagro_ocorrencia: {
            type: Number,
            default: 0
        },
    },
    data() {
        return {
            service: new OcorrenciaService(this.$http, this.$router),
            
            ocorrencia: {},
            permissao: false,
            title: "",
        };
    },
    created() {
        this.carregarDados();
    },
    methods: {
        generateId(numberId) {
            return this.$route.name+'-aba-geral-'+numberId;
        },
        carregarDados() {
            this.isLoading = true;
            this.isLoadingEdit = true;
            
            this.service.find( this.idagro_ocorrencia )
                .then(value => {
                    this.ocorrencia = Object.assign({}, value.content);
                    this.title = this.ocorrencia.nomepopular;
                })
                .catch(e => {
                    console.error(e);
                    this.$root.showMessage('error', 'msg-erro-load', true);
                });
        },
    },
};
</script>
<style lang="scss" scoped>
.page-container{
    .loading {
        opacity: 0.5;
        pointer-events: none;
    }
}
</style>